import React from 'react';
import FormSelectBox from '../../../../components/Form/FormSelectBox';

interface InicioPorContratistaProps {
  contratistas: any[];
  idContratista: string;
  tiposTrabajos: any[];
  onChangeContratista: (
    e: React.ChangeEvent<HTMLSelectElement>
  ) => void;
  onSelectTipoTrabajo: (tipoTrabajo: any) => void;
}

// CU13 (mantis 0200062): combo de contratista debe mostrar estado de habilitación
const buildEtiquetaContratista = (c: any): string => {
  const estado = c?.nombreEstadoHabilitacion;
  return estado
    ? `${c.razonSocial} – Habilitación ${estado}`
    : `${c.razonSocial} – Sin Habilitación`;
};

export const InicioPorContratista: React.FC<
  InicioPorContratistaProps
> = ({
  contratistas,
  idContratista,
  tiposTrabajos,
  onChangeContratista,
  onSelectTipoTrabajo,
}) => {
  const contratistasConEtiqueta = Array.isArray(contratistas)
    ? contratistas.map((c: any) => ({
        ...c,
        etiqueta: buildEtiquetaContratista(c),
      }))
    : contratistas;

  return (
    <>
      <div className="d-flex justify-content-center">
        <FormSelectBox
          title={'Contratista'}
          label={'contratista'}
          id={'contratista'}
          name={'idContratista'}
          onChange={onChangeContratista}
          optionId={'id'}
          optionLabel={'etiqueta'}
          value={idContratista}
          options={contratistasConEtiqueta}
          classLabel="col-form-label col-2 text-left"
          classDivSelect="col-8"
          styleLabelColor="black"
        />
      </div>
      <div className="row mt-3">
        <label className="col-form-label">Tipos de Trabajo</label>

        <div className="ms-2 p-3 card p-5">
          <div className="row">
            {tiposTrabajos?.map((tipoTrabajo: any) => {
              return (
                <div
                  className="col-3 text-center"
                  key={tipoTrabajo.id}
                >
                  <a
                    href="/tipoTrabajo"
                    onClick={(e) => {
                      e.preventDefault();
                      onSelectTipoTrabajo(tipoTrabajo);
                    }}
                  >
                    <img
                      src={`data:image/jpeg;base64,${tipoTrabajo.logo}`}
                      alt={tipoTrabajo.id}
                      width="100"
                      height="100"
                    />
                    <br />
                    <span className="fs-9">
                      {tipoTrabajo.descripcion}
                    </span>
                  </a>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};
